<template>
  <nav class="breadcrumb-nav">
    <ul class="breadcrumb-nav__list">
      <li class="breadcrumb-nav__item"><a href="/" class="breadcrumb-nav__link breadcrumb-nav__link--top">資格取得・通信講座ならユーキャン</a></li><li class="breadcrumb-nav__item">ぴったり講座診断</li>
    </ul>
  </nav>
</template>


<script>
export default {
  name: 'Footer',
}
</script>


<style scoped>
</style>